<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="normal"
      :visible.sync="modalVisible"
      no-padding
      :footer="false">
    <template #header>错误提示</template>
    <template #content>
      <div class="error-wrapper">
        <template v-if="data.bidDailies && data.bidDailies.length > 0">
          <div class="error-title">分时调整竞价</div>
          <div v-for="(item, i) in data.bidDailies"
               :key="i"
               class="error-desc">
            <div>{{item.weekStr}}：{{item.error}}</div>
          </div>
        </template>
        <template v-if="data.budgetDailiesError && data.budgetDailiesError.length > 0">
          <div class="error-title" style="margin-top: 12px;">分时调整预算</div>
          <div v-for="(item, i) in data.budgetDailiesError"
               :key="i"
               class="error-desc">
            <div>{{item.weekStr}}：{{item.error}}</div>
          </div>
        </template>
        <template v-if="data.placementDailies && data.placementDailies.length > 0">
          <div class="error-title" style="margin-top: 12px;">分时广告位竞价</div>
          <div v-for="(item, i) in data.placementDailies"
               :key="i"
               class="error-desc">
            <div>{{item.weekStr}}：{{item.error}}</div>
          </div>
        </template>
      </div>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../../../../minxins";

  export default {
    name: "app-time-adjust-strategy-op-error-modal",
    mixins: [modalMixIn],
    props: {
      data: {
        required: true
      }
    }
  }
</script>

<style scoped>
  .error-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px 20px 40px;
  }
  .error-title {
    margin-bottom: 6px;
    font-size: 14px;
    font-weight: bold;
  }
  .error-desc {
    font-size: 12px;
    text-align: center;
  }
</style>


